import type { Messages } from '@ah/i18n';

/** Greek — primary/default locale (ADR-015). Source of truth: a missing `en` key falls back here. */
export const el: Messages = {
  nav: {
    findTherapist: 'Εύρεση ψυχολόγου',
    checkIn: 'Check-in',
    settings: 'Ρυθμίσεις',
    signOut: 'Αποσύνδεση',
    signIn: 'Σύνδεση',
    back: '← Πίσω',
    backHome: 'Αρχική',
  },
  auth: {
    login: {
      title: 'Σύνδεση',
      email: 'Email',
      password: 'Κωδικός',
      submit: 'Σύνδεση',
      submitting: 'Σύνδεση…',
      missingFields: 'Παρακαλούμε συμπλήρωσε email και κωδικό.',
      resendPrompt: 'Δεν βρίσκεις το email επιβεβαίωσης; Μπορούμε να το ξαναστείλουμε.',
      resendButton: 'Στείλε ξανά το email',
      resendSent: 'Αν υπάρχει λογαριασμός με αυτό το email, στάλθηκε νέος σύνδεσμος. Δες και τον φάκελο ανεπιθύμητων.',
      resendFailed: 'Κάτι πήγε στραβά. Δοκίμασε ξανά σε λίγο.',
      failed: 'Η σύνδεση απέτυχε. Δοκίμασε ξανά.',
      noAccount: 'Δεν έχεις λογαριασμό;',
      registerLink: 'Εγγραφή ανώνυμα',
    },
    twoFactor: {
      prompt: 'Βάλε τον εξαψήφιο κωδικό από την εφαρμογή authenticator ή από το email σου.',
      codeLabel: 'Κωδικός',
      submit: 'Επιβεβαίωση',
      failed: 'Λάθος κωδικός. Δοκίμασε ξανά.',
      recoveryHint: 'Αν δεν έχεις πρόσβαση, μπορείς να βάλεις έναν εφεδρικό κωδικό (π.χ. ABCDE-12345).',
    },
    register: {
      title: 'Ξεκίνα ανώνυμα',
      intro: 'Διάλεξε ένα ψευδώνυμο — ο θεραπευτής σου δεν θα δει ποτέ το πραγματικό σου όνομα, εκτός αν επιλέξεις να το αποκαλύψεις.',
      email: 'Email',
      pseudonym: 'Ψευδώνυμο',
      pseudonymPlaceholder: 'π.χ. nyx_01',
      password: 'Κωδικός (min 10 χαρακτήρες, κεφαλαία/πεζά + αριθμός)',
      submit: 'Δημιουργία ανώνυμου λογαριασμού',
      submitting: 'Δημιουργία λογαριασμού…',
      failed: 'Η εγγραφή απέτυχε.',
      legalNoticePrefix: 'Έχω διαβάσει και αποδέχομαι τους',
      legalNoticeJoiner: 'και την',
      mustAcceptTos: 'Για να συνεχίσεις πρέπει να αποδεχτείς τους Όρους Χρήσης και την Πολιτική Απορρήτου.',
      termsLink: 'Όρους Χρήσης',
      privacyLink: 'Πολιτική Απορρήτου',
      alreadyRegistered: 'Έχεις ήδη λογαριασμό;',
      loginLink: 'Σύνδεση',
    },
  },
  therapistProfile: {
    back: 'Πίσω στους ψυχολόγους',
    fallbackName: 'Ψυχολόγος',
    loadError: 'Δεν ήταν δυνατή η φόρτωση του προφίλ.',
    notFoundHint: 'Ίσως ο σύνδεσμος να είναι παλιός ή ο θεραπευτής να μην δέχεται πια κρατήσεις.',
    servicesTitle: 'Υπηρεσίες & τιμές',
    noServices: 'Αυτός ο θεραπευτής δεν έχει ενεργές υπηρεσίες αυτή τη στιγμή.',
    perSession: 'ανά συνεδρία',
    bookNeedsAccount: 'Κλείσε συνεδρία',
    registerHint: 'Η εγγραφή ζητείται μόνο όταν κλείνεις συνεδρία. Χρειάζεται ένα ψευδώνυμο και ένα email.',
    aboutTitle: 'Λίγα λόγια',
    worksWithTitle: 'Αναλαμβάνει',
    videoTitle: 'Βίντεο παρουσίασης',
    videoPrivacy: 'Το βίντεο φιλοξενείται σε εξωτερική υπηρεσία. Φορτώνει μόνο όταν πατήσεις play.',
    yearsExperience: '{{years}} χρόνια εμπειρίας',
    licensedIn: 'Άδεια: {{country}}',
    translationMissing: 'Το προφίλ δεν έχει μεταφραστεί ακόμα — εμφανίζεται η ελληνική εκδοχή.',
  },
  agreementTerms: {
    version: 'Έκδοση {{version}}',
    clientLink: 'Όροι για πελάτες',
    therapistLink: 'Όροι για θεραπευτές',
    siteTermsLink: 'Όροι χρήσης ιστότοπου',
  },
  verifyEmail: {
    title: 'Επιβεβαίωση email',
    success: 'Το email σου επιβεβαιώθηκε. Μπορείς να συνδεθείς.',
    already: 'Αυτό το email είχε ήδη επιβεβαιωθεί. Μπορείς να συνδεθείς κανονικά.',
    noToken: 'Ο σύνδεσμος είναι ελλιπής. Άνοιξέ τον απευθείας από το email.',
    failed: 'Δεν μπορέσαμε να επιβεβαιώσουμε το email.',
    failedHint: 'Ζήτησε νέο σύνδεσμο από τη σελίδα σύνδεσης.',
    goToLogin: 'Στη σύνδεση',
  },
  home: {
    noTherapists: 'Δεν υπάρχουν ακόμα εγκεκριμένοι ψυχολόγοι σε αυτή την κατηγορία.',
    loading: 'Φόρτωση…',
    allCategories: 'Όλες οι κατηγορίες',
    defaultTherapistName: 'Ψυχολόγος',
    watchIntro: '▶ Δες το βίντεο παρουσίασης',
    fromPricePerSession: 'Από {{price}} / συνεδρία',
    bookSession: 'Κλείσε συνεδρία',
    startToBook: 'Ξεκίνα για να κλείσεις',
    translationMissing: '(δεν έχει μεταφραστεί ακόμα στα Αγγλικά)',
    speaks: 'Μιλά:',
  },
  matching: {
    title: 'Βρες θεραπευτή',
    specializationPlaceholder: 'Ειδίκευση (π.χ. άγχος) — προαιρετικό',
    languagePlaceholder: 'Γλώσσα συνεδρίας — προαιρετικό',
    anyLanguage: 'Οποιαδήποτε γλώσσα',
    search: 'Αναζήτηση',
    searching: 'Αναζήτηση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των θεραπευτών.',
    noResults: 'Κανένας θεραπευτής δεν ταιριάζει. Δοκίμασε διαφορετική ειδίκευση ή αναζήτησε χωρίς φίλτρο.',
    defaultTherapistName: 'Θεραπευτής',
    generalPractice: 'Γενική πρακτική',
    yearsExperience: '{{years}} έτη εμπειρίας',
    experienceNA: 'Εμπειρία μη διαθέσιμη',
    bookSession: 'Κλείσε συνεδρία',
    noBookableSessions: 'Δεν έχουν ρυθμιστεί ακόμα διαθέσιμες συνεδρίες.',
    translationMissing: '(προφίλ όχι ακόμα στα Αγγλικά — εμφανίζεται η ελληνική εκδοχή)',
    speaks: 'Μιλά:',
    viewProfile: 'Δες το προφίλ',
  },
  booking: {
    noBookableSessions: 'Αυτός ο θεραπευτής δεν έχει ενεργές υπηρεσίες αυτή τη στιγμή.',
    title: 'Κλείσε συνεδρία',
    titleWith: 'Κλείσε με {{name}}',
    defaultTherapistName: 'αυτόν τον θεραπευτή',
    needSignIn: 'Χρειάζεται να συνδεθείς για να κλείσεις συνεδρία.',
    signIn: 'Σύνδεση',
    noTherapistData: "Δεν έχουμε πια τη λίστα συνεδριών αυτού του θεραπευτή (η σελίδα λειτουργεί μόνο από αποτέλεσμα αναζήτησης).",
    findTherapist: 'Βρες θεραπευτή',
    sessionType: 'Τύπος συνεδρίας',
    dateTime: 'Ημερομηνία & ώρα',
    callMode: 'Τρόπος κλήσης',
    anonymousMode: 'Ανώνυμα — μόνο ήχος, αλλοιωμένη φωνή, χωρίς κάμερα',
    standardMode: 'Επώνυμα — η πραγματική σου φωνή και, αν το επιλέξεις, βίντεο',
    missingFields: 'Παρακαλούμε επίλεξε τύπο συνεδρίας και ημερομηνία/ώρα.',
    createError: 'Δεν ήταν δυνατή η δημιουργία της κράτησης. Δοκίμασε ξανά.',
    submit: 'Επιβεβαίωση κράτησης',
    submitting: 'Κράτηση…',
    almostThere: 'Σχεδόν έτοιμο',
    confirmedBody: "Η συνεδρία σου με {{name}} έχει προγραμματιστεί για {{when}}. Κρατάμε τη θέση σου μόλις εγκριθεί η πληρωμή — θα χρεωθείς μόνο όταν ο θεραπευτής αποδεχτεί. Αν ο θεραπευτής δεν απαντήσει εντός 72 ωρών, η κράτηση ακυρώνεται αυτόματα χωρίς χρέωση.",
    paymentError: 'Δεν ήταν δυνατή η έναρξη της πληρωμής. Δοκίμασε ξανά.',
    continueToPayment: 'Συνέχεια στην πληρωμή',
    redirectingToPayment: 'Μεταφορά στην πληρωμή…',
    backHome: 'Πίσω στην αρχική',
  },
  checkIn: {
    title: 'Check-in',
    intro: "Γράψε τι έχεις στο μυαλό σου. Δεν μοιράζεται με κανέναν εκτός αν το επιλέξεις — είναι ένας ιδιωτικός, γρήγορος έλεγχος πριν κλείσεις ραντεβού ή στείλεις μήνυμα σε θεραπευτή.",
    placeholder: 'Γράψε ελεύθερα — δεν υπάρχει λάθος τρόπος να το πεις.',
    ariaLabel: 'Τι έχεις στο μυαλό σου',
    submit: 'Check-in',
    submitting: 'Έλεγχος…',
    error: 'Δεν ήταν δυνατός ο έλεγχος αυτή τη στιγμή.',
    riskDetected: 'Αυτό που έγραψες ακούγεται πολύ δύσκολο αυτή τη στιγμή. Σκέψου να επικοινωνήσεις με μία από τις παρακάτω γραμμές, ή με κάποιον που εμπιστεύεσαι.',
    noRisk: 'Ευχαριστούμε που έκανες check-in. Μπορείς να συνεχίσεις σε κράτηση ή μήνυμα όποτε είσαι έτοιμος/η.',
    disclaimer: 'Αυτή η εφαρμογή δεν αντικαθιστά την επαγγελματική βοήθεια. Αν βρίσκεσαι σε κρίση, επικοινώνησε:',
    lineKlimaka: 'ΚΛΙΜΑΚΑ — Γραμμή πρόληψης αυτοκτονίας:',
    lineMinistry: 'Ψυχοκοινωνική στήριξη Υπουργείου Υγείας:',
    lineEmergency: 'Έκτακτη ανάγκη:',
    lineKlimakaSuffix: '(24/7, δωρεάν, ανώνυμα)',
    lineMinistrySuffix: '(24/7, δωρεάν)',
    back: 'Πίσω',
  },
  settings: {
    title: 'Ρυθμίσεις',
    appearance: 'Εμφάνιση',
    language: 'Γλώσσα',
    themeLight: 'Φωτεινό',
    themeDark: 'Σκοτεινό',
    themeSystem: 'Συστήματος',
    deleteAccount: 'Διαγραφή λογαριασμού',
    scheduledFor: 'Ο λογαριασμός σου έχει προγραμματιστεί για διαγραφή στις {{date}}. Μπορείς να το ακυρώσεις οποιαδήποτε στιγμή πριν από τότε.',
    cancelling: 'Ακύρωση…',
    cancelRequest: 'Ακύρωση αιτήματος διαγραφής',
    graceNotice: 'Αυτό ξεκινά μια περίοδο χάριτος {{days}} ημερών κατά την οποία μπορείς να ακυρώσεις. Μετά από αυτό, το προφίλ, τα μηνύματα και τα στοιχεία σύνδεσής σου ανωνυμοποιούνται μόνιμα. Οι κρατήσεις και τα τιμολόγια διατηρούνται μόνο όπως απαιτείται από τη φορολογική νομοθεσία, αποσυνδεδεμένα από την ταυτότητά σου. Εισήγαγε τον κωδικό σου για επιβεβαίωση.',
    password: 'Κωδικός',
    submitting: 'Υποβολή…',
    confirmDeletion: 'Επιβεβαίωση διαγραφής',
    cancel: 'Ακύρωση',
    deleteMyAccount: 'Διαγραφή λογαριασμού μου',
    deletionRequestError: 'Δεν ήταν δυνατή η υποβολή του αιτήματος διαγραφής.',
    deletionCancelError: 'Δεν ήταν δυνατή η ακύρωση του αιτήματος διαγραφής.',
    back: '← Πίσω',
  },
  call: {
    connecting: 'Σύνδεση…',
    waitingForOther: 'Αναμονή για τον άλλο συμμετέχοντα…',
    ending: 'Τερματισμός κλήσης…',
    ended: 'Η κλήση τερμάτισε — {{duration}}',
    anonymousNotice: 'Ανώνυμη κλήση — η φωνή σου είναι αλλοιωμένη, η κάμερα είναι απενεργοποιημένη.',
    mute: 'Σίγαση',
    unmute: 'Άρση σίγασης',
    endCall: 'Τερματισμός κλήσης',
    done: 'Τέλος',
    back: 'Πίσω',
    genericError: 'Κάτι πήγε στραβά.',
    needSignIn: 'Χρειάζεται να συνδεθείς για να μπεις σε αυτή την κλήση.',
    joinError: 'Δεν ήταν δυνατή η σύνδεση στην κλήση.',
  },
  legal: {
    backHome: '← Αρχική',
    termsLink: 'Όροι Χρήσης',
    privacyLink: 'Πολιτική Απορρήτου',
  },
  payments: {
    successTitle: 'Η πληρωμή εγκρίθηκε',
    successBodyPrefix: 'Ευχαριστούμε — η πληρωμή σου για αυτή τη συνεδρία',
    successBodyBooking: '(κράτηση {{id}})',
    successBodySuffix: "εγκρίθηκε και κρατείται. Δεν θα χρεωθείς εκτός αν ο θεραπευτής αποδεχτεί· αν δεν απαντήσει εντός 72 ωρών, η κράτηση ακυρώνεται αυτόματα χωρίς χρέωση.",
    backHome: 'Πίσω στην αρχική',
    cancelledTitle: 'Η πληρωμή δεν ολοκληρώθηκε',
    cancelledBody: 'Η κράτησή σου παραμένει δεσμευμένη, αλλά η πληρωμή δεν ολοκληρώθηκε. Μπορείς να δοκιμάσεις ξανά από τη λίστα κρατήσεών σου.',
  },
  common: {
    loading: 'Φόρτωση…',
    cancel: 'Άκυρο',
  },
  twoFactor: {
    title: 'Επιβεβαίωση σε δύο βήματα',
    intro: 'Ένα δεύτερο βήμα στη σύνδεση, ώστε μόνο ο κωδικός σου να μην αρκεί για να μπει κάποιος στον λογαριασμό σου.',
    off: 'Αυτή τη στιγμή είναι απενεργοποιημένη.',
    onTotp: 'Ενεργή — μέσω εφαρμογής authenticator.',
    onEmail: 'Ενεργή — με κωδικό στο email σου.',
    turnOn: 'Ενεργοποίηση',
    turnOff: 'Απενεργοποίηση',
    totpTitle: 'Εφαρμογή authenticator',
    totpBody: 'Πιο ασφαλές. Χρειάζεσαι μια εφαρμογή όπως το Google Authenticator στο κινητό σου.',
    chooseTotp: 'Χρήση εφαρμογής',
    emailTitle: 'Κωδικός στο email',
    emailBody: 'Πιο απλό. Σου στέλνουμε εξαψήφιο κωδικό σε κάθε σύνδεση. Δεν χρειάζεσαι καμία εφαρμογή.',
    chooseEmail: 'Χρήση email',
    scanHint: 'Σκάναρε τον κωδικό QR με την εφαρμογή σου και μετά γράψε τον εξαψήφιο κωδικό που εμφανίζεται.',
    qrAlt: 'Κωδικός QR για την εφαρμογή authenticator',
    manualKey: 'Ή γράψε το κλειδί χειροκίνητα',
    emailSent: 'Στείλαμε έναν εξαψήφιο κωδικό στο {{email}}.',
    resend: 'Στείλε ξανά',
    resent: 'Στάλθηκε νέος κωδικός στο {{email}}.',
    codeLabel: 'Κωδικός',
    confirm: 'Επιβεβαίωση',
    recoveryTitle: 'Εφεδρικοί κωδικοί',
    recoveryBody: 'Κράτησέ τους κάπου ασφαλή. Εμφανίζονται μόνο τώρα και δεν μπορούμε να στους ξαναδείξουμε. Χωρίς αυτούς, αν χάσεις το κινητό ή το email σου, χάνεις τον λογαριασμό.',
    savedThem: 'Τους αποθήκευσα',
    disableHint: 'Για ασφάλεια, χρειάζεται και ο κωδικός πρόσβασής σου και ένας τρέχων κωδικός δύο βημάτων.',
    passwordLabel: 'Κωδικός πρόσβασης',
    disabled: 'Η επιβεβαίωση δύο βημάτων απενεργοποιήθηκε.',
    genericError: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
  },
};
